import { setRoute } from '../actions/routing';
import { useActionDispatch } from './api';

export const useSetRoute = () => useActionDispatch(setRoute);
